/** * @author SwathiDivya Bhavaraju * @email swathidivya.bhavaraju@ul.com * @create date 2021-04-22
12:20:36 * @modify date 2021-04-22 12:20:36 * @desc [description] */
<template>
  <div class="content-wrappper">
    <div class="row m-25-10">
      <div class="col-xs-7 col-sm-8 col-lg-9 mb-15">
        <a href="javascript:void(0);" class="sub-heading" @click="back()">
          <i class="fa fa-angle-left"></i>Account Name
        </a>
      </div>
      <div
        class="col-lg-3 col-md-4 col-sm-4 col-xs-5 export-account align-right mb-15"
        v-if="selectedMenu == 'users'"
      >
        <a
          class="cursor-pointer text-color-delete-red"
          @click="$refs.users.deActivateUser(selectedUsersList)"
          :disabled="selectedUsersList.length < 3"
        >
          <img
            src="/static/images/icons/delete_icon.svg"
            alt="delete-icon"
            class="header-img-size"
          />
          <span class="header-font"> Deactivate </span>
        </a>
      </div>
      <div class="col-xs-12 mb-10" v-if="selectedMenu == 'users'">
          <span class="checkbox inline-checkbox">
            <label>
              <input
                type="checkbox"
                value="true"
                v-model="includeDeactivatedUsers"
              />
              <span class="cr">
              </span>
            </label>
          </span>
          <span>include deactivated users</span>
        </div>
    </div>
    <account-details-tabs
      :activeItem="selectedMenu"
      @selectedMenu="selectedMenuItem"
    ></account-details-tabs>
    <template v-if="selectedMenu == 'accountinfo'">
      <account-info
        :accountId="accountId"
        v-model="account"
        @selectedMenu="selectedMenuItem"
      ></account-info>
    </template>
    <template v-if="selectedMenu == 'users'">
      <account-users
        ref="users"
        :account="account"
        :accountId="accountId"
        v-model="selectedUsersList"
        :includeDeactivatedUsers="includeDeactivatedUsers"
      ></account-users>
    </template>
    <template v-if="selectedMenu == 'services'">
      <account-services :accountId="accountId"></account-services>
    </template>
  </div>
</template>
<script>
import AccountDetailsTabs from './AccountDetailsTabs.vue';
import AccountInfo from './AccountInfo.vue';
import AccountServices from './AccountServices.vue';
import AccountUsers from './AccountUsers.vue';

export default {
  components: {
    AccountDetailsTabs,
    AccountInfo,
    AccountUsers,
    AccountServices
  },
  data() {
    return {
      selectedMenu: 'accountinfo',
      accountId: '',
      includeDeactivatedUsers: false,
      selectedUsersList: [],
      account: {}
    };
  },
  props: ['roleId'],
  created() {
    this.accountId = sessionStorage.getItem('getAccountDetailsId');
    if (!this.accountId) {
      if (window.history.length > 2) this.$router.go(-1);
      else this.$router.push('/layout/launchpad');
    }
  },
  methods: {
    back() {
      if (sessionStorage.getItem('getPreviousUrl')) {
        this.$router.push(sessionStorage.getItem('getPreviousUrl'));
      } else this.$router.push('/layout/launchpad');
    },
    selectedMenuItem(menuItem) {
      this.includeDeactivatedUsers = false;
      this.selectedMenu = menuItem;
    }
  },
  beforeDestroy() {
    // sessionStorage.removeItem('getAccountDetailsId');
    sessionStorage.removeItem('getPreviousUrl');
  }
};
</script>
<style scoped>
.m-25-10 {
  margin: 25px 10px 0;
}
.sub-heading > i {
  margin-right: 6px;
}
.sub-heading {
  font-family: Roboto;
  font-style: normal;
  font-size: 18px;
  color: #0b3c61;
  cursor: pointer;
}
</style>
